<template>
  <div>
    <v-dialog
      v-model="paymentDialog"
      persistent
      :width="$vuetify.breakpoint.mobile ? '90%' : '40%'"
    >
      <v-card flat class="mx-auto">
        <div class="stickyHeader">
          <div class="d-flex justify-space-between pt-2 mx-4">
            <div class="text-lg-h5">{{ appName }} - Paygate</div>
            <v-btn
              class="deep-orange--text text--darken-4 deep-orange lighten-4"
              icon
              absolute
              right
              small
              @click="paymentDialog = false"
            >
              <v-icon class="mx-2">mdi-close</v-icon>
            </v-btn>
            <div class="mt-5">
              <div class="font-weight-bold text-body-1">
                {{ payload.amount | currency }}
              </div>
              <div class="font-weight-bold text-body-2 grey--text">
                {{ payload.sourceDocumentNo }}
              </div>
            </div>
          </div>
          <v-tabs v-model="tabs">
            <v-tab>Pay with Bank</v-tab>
            <v-tab>Pay with Ecitizen</v-tab>
            <!--<v-tab>Pay with Mpesa</v-tab>-->
            <v-tab>Confirm Payment</v-tab>
          </v-tabs>
        </div>

        <v-tabs-items v-model="tabs">
          <!--<v-tab-item>
            <v-card
              class="mx-auto"
              flat
              v-if="status === '' || status === 'pending'"
            >
              <v-card-title>
                Mpesa
                <v-spacer />
                <div class="d-flex flex-column align-end">
                  <div class="text-body-2 font-weight-bold">
                    Paybill: {{ mpesaShortCode }}
                  </div>
                  <div class="text-body-2">
                    {{ appName }}
                  </div>
                </div>
              </v-card-title>

              <mpesa :payload="payload" ref="mpesa" class="mt-n3" />
            </v-card>
            <v-card v-else>
              <Success
                :success="success"
                :payload="payload"
                :transaction="transaction"
                :message="message"
                :status="status"
                @retry="retry"
              />
            </v-card>
          </v-tab-item>-->
          <v-tab-item>
            <v-card
              class="mx-auto"
              @click="activeCheckout = 0"
              flat
              v-if="status === '' || status === 'pending'"
            >
              <cheque :payload="payload" ref="cheque" class="mt-n4" />
            </v-card>
            <v-card v-else>
              <Success
                :status="status"
                :payload="payload"
                :transaction="transaction"
                :message="message"
                @retry="retry"
              />
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card
              class="mx-auto"
              flat
              v-if="status === '' || status === 'pending'"
            >
              <v-card-title> Ecitizen </v-card-title>
              <Ecitizen :payload="payload" ref="ecitizen" class="mt-n4" />
            </v-card>
            <v-card v-else>
              <Success
                :status="status"
                :payload="payload"
                :transaction="iframe"
                :message="message"
                @retry="retry"
              />
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card
              class="mx-auto"
              flat
              v-if="status === 'pending' || status === ''"
            >
              <confirm-payment-vue :payload="payload" ref="confirmPayment" />
            </v-card>
            <v-card v-else>
              <Success
                :status="status"
                :payload="payload"
                :transaction="transaction"
                :message="message"
                @retry="retry"
              />
            </v-card>
          </v-tab-item>
        </v-tabs-items>

        <v-divider />

        <v-card-actions v-if="status === '' || status === 'pending'">
          <v-btn
            class="deep-orange--text text--darken-4 deep-orange lighten-4"
            elevation="0"
            @click="paymentDialog = false"
          >
            <v-icon class="mx-2">mdi-close</v-icon>
            close
          </v-btn>
          <v-spacer />

          <v-btn color="green" v-if="tabs === 3" @click="confirmPayment">
            Confirm Payment
          </v-btn>

          <v-btn color="green" v-else @click="submitPayment">
            PAY KES
            {{
              tabs === 0 && payload.batch
                ? Number(payload.amount) - 50
                : payload.amount | currency
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-overlay v-model="loading" opacity="0.3">
        <v-progress-circular
          indeterminate
          size="64"
          width="3"
          color="primary"
        />
      </v-overlay>
    </v-dialog>
    <app-alert />
  </div>
</template>

<script>
//import Mpesa from "../components/Mpesa";
import {
  providers as appProviders,
  appName,
  mpesaShortCode,
} from "../environment/environment";
import Cheque from "../components/Cheque";
import AppAlert from "../plugins/appAlert/AppAlert";
import Success from "../components/Success.vue";
import ConfirmPaymentVue from "../components/ConfirmPayment.vue";
import Ecitizen from "../components/Ecitizen.vue";

export default {
  name: "Checkout",
  components: {
    Cheque,
    /*Mpesa,*/ AppAlert,
    Success,
    ConfirmPaymentVue,
    Ecitizen,
  },
  data: function () {
    return {
      panels: 0,
      payload: {},
      activeCheckout: 0,
      paymentDialog: false,
      tabs: 0,
      isBatch: false,
    };
  },

  mounted() {
    Event.$on("batchCheckout", () => {
      this.isBatch = true;
    });
    setTimeout(
      Event.$on("setCheckoutDialog", (payload) => {
      this.payload = JSON.parse(atob(payload));
      console.log(this.payload);
      this.paymentDialog = true;
      if (this.isBatch) {
        const batchLength = this.payload.batch.length;
        this.payload.batch.forEach((item, i) => {
          const data = {
          sourceDocumentNo: item.sourceDocumentNo,
          payerID: this.payload.payerID,
          isBatch: this.isBatch,
        };
        this.$store.dispatch("Checkout/getBalance", data)
        .then((res) => {
          if (batchLength - i === 1) {
            this.$store.commit("Checkout/SET_BALANCE", res.data.data);
          }
        })
        .catch((error) => {
          this.$store.commit("Checkout/SET_MESSAGE", error.response.data.message);
        });
        });
      } else {
        const data = {
          sourceDocumentNo: this.payload.sourceDocumentNo,
          payerID: this.payload.payerID,
        };
        this.$store.dispatch("Checkout/getBalance", data);
        this.$store.dispatch("Checkout/getPesaflowIfram", this.payload);
      }
    })  
    , 5000);
  },

  computed: {
    balance() {
      return this.$store.getters["Checkout/balance"];
    },
    appName() {
      return appName;
    },
    mpesaShortCode() {
      return mpesaShortCode;
    },
    transaction() {
      return this.$store.getters["Checkout/transaction"];
    },
    iframe() {
      return this.$store.getters["Checkout/getIframe"];
    },
    message() {
      return this.$store.getters["Checkout/message"];
    },

    status() {
      return this.$store.getters["Checkout/transactionStatus"];
    },

    loading() {
      return this.$store.getters["Checkout/loading"];
    },

    providers() {
      let allowedProviders = this.payload.providers;

      if (allowedProviders && allowedProviders.length !== 0)
        return allowedProviders;

      return appProviders.split(",");
    },
  },

  methods: {
    retry: function () {
      this.$store.commit("Checkout/RESET_STORE");
    },

    submitPayment: function () {
      if (this.tabs === 0) {
        this.$refs.cheque.pay();
      } else if (this.tabs === 1) {
        // this.$refs.mpesa.pay()
        this.$refs.ecitizen.pay();
      }
      // else {
      //   this.$refs.cheque.pay()
      // }
    },

    confirmPayment: function () {
      this.$refs.confirmPayment.confirmPayment();
    },
  },

  watch: {
    iframe(val) {
      if (!this.payload.amount || Number(payload.amount) === 0) {
        this.payload.amount = val.amountExpected;
      }
    },
    payload(val) {
      console.log("run in watch");
      this.$forceUpdate();
      this.payload = val;
    },
    balance() {
      if (!this.balance) {
        this.$appAlert({
          title: "Balance Identified",
          text: `You have enough balance to cover this payment`,
          onClose: () => {
            this.$store.commit("Checkout/SET_TRANSACTION_STATUS", "success");
          },
        });
      } else {
        this.payload = JSON.parse(atob(this.$route.query.payload));
      }
    },
  },
};
</script>
<style>
.stickyHeader {
  position: sticky;
  top: 0;
  z-index: 999;
  background-color: #fff;
}
</style>
